<template>
  <router-link v-bind="$attrs" v-on="$listeners" :to="withLangTo">
    <slot></slot>
  </router-link>
</template>

<script>
export default {
  name: 'RouterLinkLang',
  computed: {
    withLangTo() {
      const lang = this.$route.query?.lang;

      if (!lang) {
        // 没有 lang 参数就直接返回原始跳转目标
        return this.$attrs.to;
      }

      // 有 lang 参数 → 保留传递
      if (typeof this.$attrs.to === 'string') {
        return {
          path: this.$attrs.to,
          query: { lang }
        };
      }

      return {
        ...this.$attrs.to,
        query: {
          ...(this.$attrs.to?.query || {}),
          lang
        }
      };
    }
  }
};
</script>
